export default "__VITE_ASSET__Dc9cv9YF__"